import { Pipe, PipeTransform } from '@angular/core';
import { EventService } from "../service/event.service";
import { Subject, BehaviorSubject } from "rxjs";

@Pipe({
  name: 'attendance'
})
export class AttendancePipe implements PipeTransform {

 state;
  transform(value: any, args?: any): any {
    var data = [];
    var index = 0;
    console.log(args,args.attenders.length, '--------------------------------')
    for(var i=0; i < args.attenders.length; i++){
      data.push(args.attenders[i].id);
      console.log(data, args.attenders[i].id,"=====================")
      index = i;
    }
    console.log(data, args.user, data.indexOf(args.user))
    if(index == args.attenders.length - 1){
      console.log(data, args.user, data.indexOf(args.user))
      if(data.indexOf(args.user) >= 0){
        return "Attending";
      }else{
        return "Attend";
      }
    }
  }

}
